import React from "react";
import { Link } from "react-router-dom";

export default function HomeSubcontractorCTA() {
  return (
    <section className="section-pad bg-br-paper">
      <div className="container-br grid md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-7">
          <div className="br-eyebrow">Subcontractor Partnerships</div>
          <h2 className="br-headline text-3xl sm:text-4xl mt-3">Reliable Trade Partners Welcome</h2>
          <p className="mt-3 text-gray-700">Black Ridge Construction is building a network of insured, communicative subcontractors and trade partners for residential construction, roofing, remodeling, and maintenance work across the Austin area.</p>
        </div>
        <div className="md:col-span-5">
          <Link to="/subcontractor-partnerships" className="br-btn-dark">Apply to Partner With Us</Link>
        </div>
      </div>
    </section>
  );
}
